export default "__VITE_ASSET__2EXiT_6a__"